import {
    PORTABILITY_ACTION,
    PORTABILITY_ACTION_ERROR,
    CLEAN_PORTABILITY_ACTION,
    CLEAN_PORTABILITY_ACTION_ERROR,
} from "_models/redux/types";

const initialState = {
    payload: undefined,
    status: undefined,
    loaded: undefined,
    state: undefined,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case PORTABILITY_ACTION:
            return {
                ...state,
                loaded: true,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "success",
            };
        case PORTABILITY_ACTION_ERROR:
            return {
                ...state,
                loaded: true,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "error",
            };

        case CLEAN_PORTABILITY_ACTION:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "success",
            };
        case CLEAN_PORTABILITY_ACTION_ERROR:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "error",
            };

        default:
            return state;
    }
}
